<div
    class="row"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    Dashboard is working
</div>
